/* theme builder drawer guide panel pop out */

//////////////////////////////////////////
//builder guide panel image slider -  trigger fancy box when jquery loaded .jquery-is-loaded 
//waitForElm('html.q-is-loaded .builder-guidelines-trigger', true).then((elm) => {
//$q('html.q-is-loaded #cd-builder .field .builder-guidelines-trigger').wait(true,(elm) => {
$q('html.q-is-loaded .cd-builder-ready .builder-guidelines-trigger').wait(true,(elm) => {

  //console.log('.builder-guidelines-trigger exists');

  //////////////////////////////////////////
  // builder - measurement guidelines pop out
  //waitForElm('html.is-products #builder-drawer #builder-guidelines details-disclosure', true).then((elm) => {
  $q('html.is-products #builder-drawer #builder-guidelines details-disclosure').wait(true,(elm) => {

    //console.log('.builder-guidelines-trigger discolosure exists');
    
    //console.log("builder-drawer details-disclosure exists");
    //waitForElm('html.is-products td > .field .builder-guidelines-trigger', true).then((elm) => {
    //$q('html.is-products td > .field .builder-guidelines-trigger').wait(true,(elm) => {
    $q('html.is-products .builder-guidelines-trigger').wait(true,(elm) => {
      
      //console.log("builder-drawer builder-guidelines-trigger exists");
      var builderDrawer = document.querySelector('#builder-drawer');
      var builderGuidelines = builderDrawer.querySelector('#builder-drawer #builder-guidelines');
      var builderOverlay = document.querySelector('body > .overlay.js-overlay');
      var panelBuilderOverlay = document.querySelector('.panel-drawer.builder-drawer-overlay');  
      //for (var builderGuidelinesTrigger of document.querySelectorAll(".builder-guidelines-trigger")) {

        //console.log(builderGuidelinesTrigger);
  
        // trigger open of builder-drawer pop out
        //builderGuidelinesTrigger.addEventListener("click", function(e){ 
        document.querySelector('#main-content').addEventListener("click", function(event){
        //$q(".builder-guidelines-trigger").on("click", function(event){

          //console.log('builder-guidelines-trigger');
          
          const targetElement = event.target.closest(".builder-guidelines-trigger");
          if(this.contains(targetElement) && targetElement){
            event.preventDefault();
            let el = this;
            //console.log('.builder-guidelines-trigger clicked');
            //console.log('builderDrawer.hasAttribute("open")',builderDrawer.hasAttribute("open"));
            if(builderDrawer.hasAttribute("open") == false){         
              builderDrawer.setAttribute("open","");              
              $q(document.documentElement).addClass("modal-visible-drawer");
              $q(builderOverlay).addClass("is-visible");
              if(document.documentElement.classList.contains('has-media-svg-diagram')){
                $q(panelBuilderOverlay).addClass("is-visible");
                panelBuilderOverlay.removeAttribute('hidden');
              }
              //console.log('targetElement',targetElement);
              //console.log('targetElement.dataset.guidelineKey',targetElement.dataset.guidelineKey);
              if(typeof targetElement.dataset.guidelineKey != "undefined"){// || targetElement.dataset.guidelineKey != null
                let dataGuidelineKey = "";
                if(typeof targetElement.dataset.guidelineKey != "undefined"){
                  dataGuidelineKey = targetElement.dataset.guidelineKey;
                }              
                //console.log(dataGuidelineKey);
                if(dataGuidelineKey == "" && dataGuidelineKey != "undefined"){
                    // #itoris_dynamicproductoptions  data-builder-product-type="product-type-grommet"
                    let whatBuilderType  = document.querySelector('#itoris_dynamicproductoptions').dataset.builderProductType.replace("product-type-","");
                    //console.log('whatBuilderType',whatBuilderType);
                    for (var guideline of builderGuidelines.querySelectorAll('details-disclosure[data-guideline]')) {
                        //console.log(guideline);
                        let dataGuideline = guideline.dataset.guideline;
                        //console.log(dataGuideline);
                        if(whatBuilderType.indexOf(dataGuideline) != -1){
                            //console.log('match:',dataGuideline);
                            dataGuidelineKey = whatBuilderType;
                        }
                    }
                }              
                if(builderGuidelines.querySelector('details-disclosure[data-guideline="' + dataGuidelineKey + '"] .disclosure.disclosure--row') !== null){                
                  let activeGuideline = builderGuidelines.querySelector('details-disclosure[data-guideline="' + dataGuidelineKey + '"] .disclosure.disclosure--row');
                  setTimeout(function(){
                    activeGuideline.setAttribute("open","");
                    // Scroll the target element into view within its scrollable ancestor (the nested container)
                    setTimeout(function(){
                      //let nestedContainer = document.querySelector("#builder-guidelines");
                      let targetElement = activeGuideline;
                      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    },1000);
                  },1000);
                }
              }
            }
          }
        });
      //}
      function closeBuilderDrawer(e){
        
          e.preventDefault();
          let el = this;
          if(builderDrawer.hasAttribute("open") == true){
            $q(builderOverlay).removeClass("is-visible");
            if(document.documentElement.classList.contains('has-media-svg-diagram')){
              $q(panelBuilderOverlay).removeClass("is-visible");
              panelBuilderOverlay.setAttribute('hidden','');
            }
            builderDrawer.removeAttribute("open");
            Util.removeClass(document.documentElement, "modal-visible-drawer");
            setTimeout(function(){
              for (var detailsDisclosure of builderGuidelines.querySelectorAll("details-disclosure")) {
                  detailsDisclosure.querySelector(".disclosure.disclosure--row").removeAttribute("open");
              }
            },700);
          }       
       }      
       // builder drawer close button pop in
       builderDrawer.querySelector('.builder-drawer__close-btn.js-close-builder-drawer').addEventListener("click", closeBuilderDrawer);
       builderOverlay.addEventListener("click", closeBuilderDrawer);
       panelBuilderOverlay.addEventListener("click", closeBuilderDrawer);
     });
  });


  // craete builder drawer image slider for each details disclosure
  if (document.querySelector(".ecs-slider--dummy-images img") !== null) {
    
    let count = 0;
    for (var articleContainer of document.querySelectorAll(".ecs-slider .ecs-slider-container")) {
      
      let ecsSlider = articleContainer.parentElement;
      let ecsSliderCardMedia = articleContainer.parentElement.parentElement;
      let imgIndex = 0;
      let dummyImagesBox = ecsSliderCardMedia.querySelector(".ecs-slider--dummy-images");
      let imgUrlsArr = [...dummyImagesBox.querySelectorAll("img")].map((img) => img.src);
      //console.log(imgUrlsArr);

      if(imgUrlsArr.length > 0){
  
        let image460px = imgUrlsArr[imgIndex];
        let image700px = imgUrlsArr[imgIndex].replace("460", "700");//zoom-origin
    
        articleContainer.innerHTML = `<a href="${image700px}" class="jonnyzoom builder-guide-modal" data-group="set${count}"><img src="${image460px}" class="ecs-slider-image img-fit"></a>`;
        //articleContainer.innerHTML = `<a href="${image700px}" class="fancybox builder-guide-modal"><img src="${image460px}" class="ecs-slider-image img-fit"></a>`;
        /*articleContainer.innerHTML = `<img data-srcset="${image460px} 460w, ${image700px} 700w" 
               sizes="(min-width: 1388px) calc((1260px - 24px) / 2), (min-width: 1280px) calc((100vw - 152px) / 2), (min-width: 769px) calc((100vw - 120px) / 2), (min-width: 600px) calc(100vw - 96px), calc(100vw - 40px)" 
               data-src="${image460px}" 
               class="video-played-hidden img-fit no-js-hidden" 
               style="object-position: 50.0% 50.0%" 
               loading="lazy" 
               width="460" 
               height="460" 
               alt="" 
               src="${image460px}" 
               srcset="${image460px} 460w, ${image700px} 700w">`;*/

        if(imgUrlsArr.length > 1){
        
          ecsSlider.querySelector(".ecs-slider--left-arrow").style.display = '';
          ecsSlider.querySelector(".ecs-slider--right-arrow").style.display = '';
      
          ecsSlider.querySelector(".ecs-slider--left-arrow").addEventListener("click", function (e) {
            
              e.preventDefault();
              //console.log(imgIndex);
              //console.log(imgUrlsArr);
      
              if (imgIndex > 0 && imgIndex < imgUrlsArr.length) {
                imgIndex--;
              } else {
                imgIndex = imgUrlsArr.length - 1;
              }
              image460px = imgUrlsArr[imgIndex];
              image700px = imgUrlsArr[imgIndex].replace("460", "700");
              this.parentElement.parentElement.querySelector(".ecs-slider-container").//innerHTML = `<a href="${image700px}" class="fancybox builder-guide-modal"><img src="${image460px}" class="ecs-slider-image img-fit"></a>`;zoom-origin
              innerHTML = `<a href="${image700px}" class="jonnyzoom builder-guide-modal" data-group="set${count}"><img src="${image460px}" class="ecs-slider-image img-fit"></a>`;
              //jonnyZoomReInit();
            });
      
          ecsSlider.querySelector(".ecs-slider--right-arrow").addEventListener("click", function (e) {
            
              e.preventDefault();
              //console.log(imgIndex);
              //console.log(imgUrlsArr);
      
              if (imgIndex >= 0 && imgIndex < imgUrlsArr.length - 1) {
                imgIndex++;
              } else {
                imgIndex = 0;
              }
              image460px = imgUrlsArr[imgIndex];
              image700px = imgUrlsArr[imgIndex].replace("460", "700");
              //this.parentElement.parentElement.querySelector(".ecs-slider-container").innerHTML = `<a href="${image700px}" class="fancybox builder-guide-modal"><img src="${image460px}" class="ecs-slider-image img-fit"></a>`;zoom-origin
              this.parentElement.parentElement.querySelector(".ecs-slider-container").innerHTML = `<a href="${image700px}" class="jonnyzoom builder-guide-modal" data-group="set${count}"><img src="${image460px}" class="ecs-slider-image img-fit"></a>`;
              //jonnyZoomReInit();
            });

        } else {

          ecsSlider.querySelector(".ecs-slider--left-arrow").style.display = 'none';
          ecsSlider.querySelector(".ecs-slider--right-arrow").style.display = 'none';
        }  

      } else {
        ecsSlider.querySelector(".ecs-slider--left-arrow").style.display = 'none';
        ecsSlider.querySelector(".ecs-slider--right-arrow").style.display = 'none';
      }  

      count++;
    }
  
    function jonnyZoomReInit() {
      
      /* jQuery().fancybox({
        selector: ".fancybox.builder-guide-modal",
        parentEl: "#main-content",
        arrows: false,
        toolbar: true,
        vertical: false,
        loop: false,
        autoFocus: false,
        hash: false,
        clickSlide: "close",
        clickOutside: "close",
        thumbs: {
          autoStart: false, // Display thumbnails on opening
          hideOnClose: true, // Hide thumbnail grid when closing animation starts
          axis: "y", // Vertical (y) or horizontal (x) scrolling
        },
        buttons: ["close"],
      }); */
      jonnyZoom('#builder-drawer', { }, 'panelGallery');
    }
    jonnyZoomReInit();

    //close filter dropdown inside lateral .fp-filter
	/*for (var fpFilterBlockH4 of document.querySelectorAll('#builder-drawer .builder-drawer__content .disclosure--row .product-info__disclosure')) {

		fpFilterBlockH4.addEventListener("click", function(event) {

			let selectedItem = this;
			let bool = true;
			if(Util.hasClass(selectedItem, 'closed')){
				bool = false;
			}
			Util.toggleClass(selectedItem, 'closed', bool);
			selectedItem.parentElement.querySelector('.fp-filter-content').slideToggle(300);
		});
	}*/
  }

});
